// extracted by mini-css-extract-plugin
module.exports = {"chat":"_3HWRAVUnQF-Fxu1yV3R1WP","messages":"U9xRSLIKZiHXRKV8AkeNp","anchor":"_1oEh2fP8bWMqoV6wDD1FrW"};